import { makeStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) => ({
  loadingProgress: {
    top: '50%',
    position: 'absolute',
    alignSelf: 'center'
  }
}));